@if (productStoryblok$|async; as productStoryblok) {
  @if (product()?.id) {
    <div class="row">
      <div class="food-title col-md-2 col-sm-12">
        <p>Passer godt til</p>
      </div>
      <div class="food-images col-md-10 col-sm-12">
        @for (food of product()?.meta?.foods; track food?.label) {
          <div class="food-image">
            <a (click)="trackEvent(food?.label)" [appRouterContext]="'food-icon'" [routerLink]="food?.path">
              <img [ngSrc]="productService.getItemIcon(food?.iconName ?? '', productStoryblok)" height="40" width="40"/>
              <p>{{ food?.label }}</p>
            </a>
          </div>
        }
      </div>
    </div>
  }
}
